import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v1`;

const client = axios.create({
  baseURL: API,
  timeout: 30_000,
});

// ---- Error shape ---------------------------------------------------------
export class OmniApiError extends Error {
  constructor(message, { status, attempts } = {}) {
    super(message);
    this.name = "OmniApiError";
    this.status = status;
    this.attempts = attempts || [];
  }
}

function unwrapError(err, fallbackMsg) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object") {
    return new OmniApiError(detail.message || fallbackMsg, {
      status,
      attempts: detail.attempts,
    });
  }
  return new OmniApiError(
    typeof detail === "string" ? detail : err?.message || fallbackMsg,
    { status },
  );
}

// ---- Endpoints -----------------------------------------------------------
export async function fetchTickers({ refresh = false } = {}) {
  try {
    const { data } = await client.get("/tickers", {
      params: refresh ? { refresh: true } : {},
    });
    return data;
  } catch (e) {
    throw unwrapError(e, "Failed to fetch tickers");
  }
}

export async function fetchProviders() {
  try {
    const { data } = await client.get("/providers");
    return data;
  } catch (e) {
    throw unwrapError(e, "Failed to fetch providers");
  }
}

export async function fetchHealth() {
  try {
    const { data } = await client.get("/health");
    return data;
  } catch (e) {
    throw unwrapError(e, "Failed to fetch health");
  }
}

export async function fetchQuote(ticker) {
  try {
    const { data } = await client.get("/quote", { params: { ticker } });
    return data;
  } catch (e) {
    throw unwrapError(e, `Failed to fetch quote for ${ticker}`);
  }
}

export async function fetchHistorical(ticker, days) {
  try {
    const { data } = await client.get("/historical", {
      params: { ticker, days },
    });
    return data;
  } catch (e) {
    throw unwrapError(e, `Failed to fetch historical for ${ticker}`);
  }
}

export async function fetchLogs({ limit = 200, level, contains } = {}) {
  try {
    const { data } = await client.get("/logs", {
      params: { limit, level, contains },
    });
    return data;
  } catch (e) {
    throw unwrapError(e, "Failed to fetch logs");
  }
}
